import * as React from "react";

const IconCarouselLeftHover: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="currentColor"><g fill="none" fillRule="evenodd"><circle cx="22" cy="22" r="22" fill="#FFF"/><polygon fill="#587A81" fillRule="nonzero" points="24 32 26.5 29.5 19 22 26.5 14.5 24 12 14 22"/></g></svg>;
};

export default React.memo(IconCarouselLeftHover);
